import React from 'react';
import '../../../stylesheets/lis-public-view/public-view.css';
import { Link } from 'react-router-dom';
import moment from 'moment-timezone';
import { withRouter } from 'react-router';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { navActionCreators } from '../../../stores/lis-nav-store';
import { HistoricalRedirectPopup } from '../../../lis-shared/lis-layout/components/lis-popup-component';

class SessionInfo extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
        this.handleSessionChange = this.handleSessionChange.bind(this);
    }

    handleSessionChange(value) {
        if (window.env && window.env.HISTORICAL_DATA_REDIRECT && value && !value.IsDefault && value.LegacySessionID && value.SessionCode != "20242") {
            this.setState({
                historicalSessionRedirect: (redirect) => {
                    if (redirect) {
                        let a = document.createElement('a');
                        a.target = '_blank';
                        a.href = `https://legacylis.virginia.gov/cgi-bin/legp604.exe?ses=${value.SessionCode.substring(2)}&typ=lnk&val=${value.LegacySessionID}`;
                        document.body.appendChild(a);
                        a.click();
                        document.body.removeChild(a);
                    }
                    this.setState({ historicalSessionRedirect: false })
                }
            })
            return;
        }
        if (value && value.SessionCode) {
            this.props.actions.changeSession(value.SessionCode);
        }
    }

    render() {
        const session = this.props.selectedSession;
        const adjournment = session ? session.SessionEvents.find(event => event.DisplayName === "Adjournment") : null;
        const reconvene = session ? session.SessionEvents.find(event => event.DisplayName === "Reconvene") : null;
        const start = session ? session.SessionEvents.find(event => event.DisplayName === "Session Start") : null;

        let activeSessions = [];
        if (session.IsActive) {
            activeSessions = this.props.sessionList.filter(s => s.IsActive && s.SessionID !== session.SessionID);
        }

        const baseUrl = `http${window.location.href.includes('lis') ? 's' : ''}://${window.location.host}`;

        return (
            <div>
                {this.state.historicalSessionRedirect &&
                    <HistoricalRedirectPopup closePopup={() => this.state.historicalSessionRedirect(false)} redirect={() => this.state.historicalSessionRedirect(true)} />
                }
                <h3 className="homepage-header">{session.SessionYear} {session.SessionType === "Special" ? session.DisplayName : "Session"} Information</h3>
                <hr />
                {!this.props.isLoaded ?
                    <div className="center-spinner spinner small-height" />
                    :
                    <section>
                        <section className="homepage-links">
                            <span>Session dates: {moment(start ? start.ActualDate : '').tz('America/New_York').format('MMMM D, YYYY')}{adjournment &&
                                <span> - {moment(adjournment ? adjournment.ActualDate : '').tz('America/New_York').format('MMMM D, YYYY')}</span>
                            }</span>
                            {reconvene &&
                                <span>Reconvened: {moment(reconvene.ActualDate).tz('America/New_York').format('MMMM D, YYYY')}</span>
                            }
                        </section>
                        <section className="homepage-links">
                            <Link to={`/session-details/${session.SessionCode}/member-information`}>Delegates & Senators</Link>
                            <Link to={`/session-details/${session.SessionCode}/committee-information`}>Standing Committees</Link>
                            <Link to={`/session-details/${session.SessionCode}/calendar`}>Daily Floor Calendars</Link>
                            <Link to={`/session-details/${session.SessionCode}/communications`}>Communications</Link>
                        </section>
                        <section className="homepage-links">
                            <span>Minutes: {session.SessionYear < 2010
                                ? <Link to={`/session-details/${session.SessionCode}/minutes-list/house`}>House</Link>
                                : <a href={"https://house.vga.virginia.gov/minutes?ses=" + session.SessionCode.toString().substr(2, 3)}>House</a>}
                                <span style={{ margin: '0px 5px', color: '#ccc' }}>|</span>
                                <Link to={`/session-details/${session.SessionCode}/minutes-list/senate`}>Senate</Link>
                            </span>
                            <span>Video: <a href="https://house.vga.virginia.gov/now_playing">House</a>
                                <span style={{ margin: '0px 5px', color: '#ccc' }}>|</span>
                                <a href="https://www.youtube.com/@SenateofVirginia">Senate</a>
                            </span>
                            <span>Committee Statistics: <Link to={`/session-details/${session.SessionCode}/statistics/committee/h`}>House</Link>
                                <span style={{ color: '#ccc' }}> | </span>
                                <Link to={`/session-details/${session.SessionCode}/statistics/committee/s`}>Senate</Link>
                            </span>
                            <span>Session Statistics: <Link to={`/session-details/${session.SessionCode}/statistics/status`}>By Status</Link> </span>
                        </section>
                    </section>
                }
                {this.props.isLoaded && activeSessions.length > 0 &&
                    <section className="homepage-links">
                        <span>Concurrent Sessions:</span>
                        {activeSessions.map(activeSession =>
                            <span key={activeSession.SessionID}>
                                <a style={{ cursor: 'pointer' }} href={`${baseUrl}/home/${activeSession.SessionCode}`} onClick={(e) => { e.preventDefault(); this.handleSessionChange(activeSession) }}>{activeSession.SessionYear} {activeSession.DisplayName}</a>
                            </span>
                        )}
                    </section>
                }
            </div>
        );
    }
}

export default connect(
    (state) => {
        const { nav } = state;
        return {
            nav
        }
    },
    (dispatch) => {
        return {
            actions: bindActionCreators(Object.assign({}, navActionCreators), dispatch)
        }
    }
)(withRouter(SessionInfo))
